import { createFileRoute, Link } from '@tanstack/react-router'
import { SkeletonRows } from '@/components/rm'
import { useT } from '@/i18n'
import { fmtDateTime } from '@/lib/ph'
import { useThreads } from '@/lib/messages'

// Spec 006. The client's conversations, newest first.
export const Route = createFileRoute('/_client/messages')({ component: ClientInbox })

function ClientInbox() {
  const { t } = useT()
  const threads = useThreads('client')
  return (
    <div className="space-y-4">
      <h1 className="font-display text-[22px] font-bold tracking-[-0.02em] text-token-primary">{t('msg.nav')}</h1>
      {threads.isLoading && <SkeletonRows count={3} />}
      {!threads.isLoading && (threads.data ?? []).length === 0 && <p className="rounded-[16px] border border-token-subtle bg-token-surface p-5 text-[14px] text-token-secondary">{t('msg.inboxEmpty')}</p>}
      <ul className="space-y-2">
        {(threads.data ?? []).map((th) => (
          <li key={th.id}>
            <Link to="/messages/$id" params={{ id: th.id }} className="flex items-start gap-3 rounded-[14px] border border-token-subtle bg-token-surface p-3.5 hover:border-token-strong">
              <span className="min-w-0 flex-1">
                <span className="flex items-baseline justify-between gap-2">
                  <span className="truncate text-[15px] font-bold text-token-primary">{th.counterpart}</span>
                  {th.last_message_at && <span className="flex-none text-[11.5px] text-token-muted">{fmtDateTime(th.last_message_at)}</span>}
                </span>
                {th.task_title && <span className="block truncate text-[12px] text-token-secondary">{t('msg.about', { task: th.task_title })}</span>}
                <span className="mt-0.5 block truncate text-[13.5px] text-token-secondary">{th.last_message ?? ''}</span>
              </span>
              {th.unread > 0 && <span className="mt-1 flex h-5 min-w-5 flex-none items-center justify-center rounded-full bg-brand px-1.5 text-[11px] font-bold text-brand-fg">{th.unread}</span>}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
